import type { AxiosRequestConfig } from 'axios';
import { apiRoutes } from '../../api-routes';
import { publicHttpClient } from '../../util';
import type { CancelReason } from './types';
export type GetCancelReason = {
  user_type: string;
  reason_type: string;
  service_id: string;
};
export const getCancelReasonsFn = async (
  { reason_type, user_type, service_id, ...params }: GetCancelReason,
  config: AxiosRequestConfig = {}
) => {
  const response = await publicHttpClient.get<CancelReason[]>(
    apiRoutes.testing_tool.get_cancel_reasons({
      reason_type,
      user_type,
      service_id,
    }),
    {
      params,
      ...config,
    }
  );
  return response.data;
};
